/* @flow */
import React from 'react';
import Activities from 'collections/Activities';
import Select from 'components/Select.jsx';
import FieldSet from 'components/Fieldset.jsx';
import Legend from 'components/Legend.jsx';
import Activity, { ACTIVITY_PRINTED_MSG } from 'entities/Activity';
import SettingsContainer from 'settings/components/SettingsContainer.jsx';
import ToastActions from 'actions/ToastActions';
import Button from 'components/Button.jsx';
import Field from 'components/Field.jsx';
import Label from 'components/Label.jsx';

type Props = {
  activities: Activities,
}

type State = {
  selectedActivityId: ?string,
}


export default class PrintActivity extends React.Component {
  props: Props;

  state: State;

  state = {
    selectedActivityId: this.props.activities.first() && this.props.activities.first().id,
  }

  getFormattedActivitySelectOptions() {
    return this.props.activities.map((activity) => {
      return { label: activity.getTitle(), value: activity.id };
    });
  }

  setSelectedActivity = (value: string) => {
    this.setState({ selectedActivityId: value });
  }

  printActivity = () => {
    if (this.state.selectedActivityId) {
      Activity.export(this.state.selectedActivityId)
        .then(
          () => ToastActions.showSuccessToast(ACTIVITY_PRINTED_MSG),
          () => ToastActions.showDefaultErrorToast()
        );
    }
  }

  render() {
    const options = this.getFormattedActivitySelectOptions();
    return (
      <div className="PrintActivity PrintSettingSection">
        <FieldSet>
          <Legend>
            Activity
            <p>
              Export a PDF of your activity.
            </p>
          </Legend>

          <SettingsContainer>
            <Field>
              <Label>Activity</Label>
              <Select
                options={options}
                value={this.state.selectedActivityId}
                onChange={this.setSelectedActivity}
              />
            </Field>
          </SettingsContainer>
          <Button size="small" disabled={!this.state.selectedActivityId} onClick={this.printActivity} >
            Export
          </Button>
        </FieldSet>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/settings/components/PrintActivity.jsx